<template>
  <div class="folder-node-selection-count folder-node-selection-count__root">
    <pui-flex
      v-if="count > 0"
      class="folder-node-selection-count__count"
      justifyContent="center"
      alignItems="center"
    >
      {{ count }}
    </pui-flex>
  </div>
</template>

<script>
export default {
  props: {
    /**
     * The number of selected files in this folder and it's recursive children
     */
    count: {
      type: Number,
      default: 0,
    },
  },
};
</script>
